import {
  CONTENT_WIDTH,
  bottomMarginItemGlobal
} from "../../utils/pdfConstants";

export function renderMaaperaBlock({
  contentWidth = CONTENT_WIDTH,
  content = [],
  rakennusData,
  fontSize = 10
} = {}) {
  if (!content) {
    throw new Error("content is required");
  }

  const buildings =
    rakennusData?.rakennukset_fulls ||
    rakennusData?.rakennukset ||
    [];

  const smallFontSize = fontSize * 0.85;

  const GREEN = "#04aa00";
  const LIGHT_GREY = "#f0f0f0";
  const WHITE = "#ffffff";

  const createCell = (
    text,
    {
      bold = false,
      color = "black",
      fillColor
    } = {}
  ) => ({
    text: text ?? "–",
    bold,
    color,
    fillColor,
    font: "Lato",
    fontSize: smallFontSize
  });

  const allMaapera = buildings.flatMap(
    building =>
      building.aluetiedot?.maapera || []
  );

  // Poistetaan duplikaatit
  const uniqueMaapera = [];
  const seen = new Set();

  allMaapera.forEach(item => {
    const key =
      item.id ||
      `${item.x || ""}|${item.y || ""}`;

    if (!seen.has(key)) {
      seen.add(key);
      uniqueMaapera.push(item);
    }
  });

  const body = [
    [
      {
        ...createCell("Maaperän tila", {
          bold: true,
          color: WHITE,
          fillColor: GREEN
        }),
        colSpan: 2
      },
      {}
    ]
  ];

  if (uniqueMaapera.length > 0) {
    uniqueMaapera.forEach((item, index) => {
      const fillColor =
        index % 2 === 0
          ? LIGHT_GREY
          : WHITE;

      body.push([
        createCell(
          "Lähialueella on Maaperän tilan Matti-tietojärjestelmään merkitty kohde",
          {
            fillColor
          }
        ),
        createCell(
          item.etäisyys || "–",
          {
            fillColor
          }
        )
      ]);
    });
  } else {
    body.push([
      {
        ...createCell(
          "Lähialueella ei havaittu Maaperän tilan MATTI-tietojärjestelmään merkittyjä kohteita."
        ),
        colSpan: 2
      },
      {}
    ]);
  }

  const TABLE_WIDTH =
    contentWidth * 0.92;

  content.push({
    table: {
      widths: [
        TABLE_WIDTH * 0.70,
        TABLE_WIDTH * 0.35
      ],
      body
    },

    layout: {
      hLineWidth: () => 0,
      vLineWidth: () => 0,
      paddingLeft: () => 4,
      paddingRight: () => 4,
      paddingTop: () => 4,
      paddingBottom: () => 4,
      dontBreakRows: false
    },

    margin: [
      0,
      0,
      0,
      bottomMarginItemGlobal
    ]
  });
}